import axios from 'axios'
import { CANCELAR_RESERVAS_COM_REEMBOLSO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cancelarReservasComReembolso (parametros) {
  const url = `${URL}/reserva/cancelar-reservas-com-reembolso`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CANCELAR_RESERVAS_COM_REEMBOLSO,
        payload: response
      })
  );
}
